module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image9.2af898dc.webp";